export default __webpack_public_path__ + "static/img-fluke-500x325-219c3691416ad6e18bfd8dadb02d5e96.png";